// Copyright © 2026 Gian Marco Cappelli — SAPIENS (finsapiens.it). Tutti i diritti riservati. Sviluppato su commissione esclusiva. Vietata la riproduzione senza autorizzazione scritta.
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Doughnut } from 'react-chartjs-2';
import { Label } from '../ui/label';
import { EducBox, ChartBox, ResultCard, InputRow, EDUC, fmt, calcIRPEF } from './shared';

const StipendioCalc = () => {
  const [ral, setRal] = useState('35000');
  const [tipo, setTipo] = useState('dipendente');

  const R = parseFloat(ral) || 0;
  const inps = R * (tipo === 'dipendente' ? 0.0919 : 0.26);
  const imponibile = R - (tipo === 'dipendente' ? inps : 0);
  const irpef = calcIRPEF(imponibile);
  const netto = R - irpef - inps;
  const nettoMensile = netto / 12;

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <EducBox text={EDUC.stipendio} />
      <div className="grid sm:grid-cols-2 gap-4 mb-6">
        <InputRow label="RAL lorda annua (€)" value={ral} onChange={setRal} prefix="€" />
        <div>
          <Label className="text-[#888780] text-sm">Tipo contratto</Label>
          <div className="flex gap-3 mt-1">
            <button onClick={() => setTipo('dipendente')} className={`px-4 py-2 rounded-xl text-sm font-medium transition-all ${tipo === 'dipendente' ? 'bg-[#3D7A52] text-white' : 'bg-[#252523] text-[#888780] border border-white/[0.08]'}`}>Dipendente</button>
            <button onClick={() => setTipo('partita_iva')} className={`px-4 py-2 rounded-xl text-sm font-medium transition-all ${tipo === 'partita_iva' ? 'bg-[#3D7A52] text-white' : 'bg-[#252523] text-[#888780] border border-white/[0.08]'}`}>P.IVA</button>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
        <ResultCard label="Stipendio netto mensile" value={`€${fmt(nettoMensile)}`} green />
        <ResultCard label="Netto annuo" value={`€${fmt(netto)}`} green />
        <ResultCard label="IRPEF pagata" value={`€${fmt(irpef)}`} gold />
        <ResultCard label="INPS/Contributi" value={`€${fmt(inps)}`} />
      </div>
      <ChartBox title="Ripartizione del tuo reddito" height={380}>
        <Doughnut
          data={{
            labels: ['Netto', 'IRPEF', 'INPS/Contributi'],
            datasets: [{ data: [Math.round(netto), Math.round(irpef), Math.round(inps)], backgroundColor: ['#3D7A52', '#C9A84C', '#2A4A35'], borderWidth: 2, borderColor: '#1C1C1A' }],
          }}
          options={{
            responsive: true, maintainAspectRatio: false, cutout: '65%',
            plugins: {
              legend: { display: true, position: 'bottom', labels: { color: '#888780', padding: 16, usePointStyle: true } },
              tooltip: { callbacks: { label: (ctx) => `${ctx.label}: €${fmt(ctx.parsed)} (${Math.round(ctx.parsed / R * 100)}%)` } },
            },
          }}
        />
      </ChartBox>
</motion.div>
  );
};

export default StipendioCalc;
